import { useEffect, useRef } from 'react';
import { withWindow } from '@shared/utils/withWindow';

/**
 * Prevents scroll issues on mobile devices when the tour overlay is active.
 */
export const useTourBodyScrollLock = (isOpen: boolean): void => {
  const originalOverflowRef = useRef<string | null>(null);

  useEffect(() => {
    return withWindow(
      global => {
        if (isOpen) {
          if (originalOverflowRef.current === null) {
            originalOverflowRef.current = global.document.body.style.overflow || '';
          }
          global.document.body.style.overflow = 'hidden';
        }

        return () => {
          if (originalOverflowRef.current !== null) {
            global.document.body.style.overflow = originalOverflowRef.current;
            originalOverflowRef.current = null;
          }
        };
      },
      () => {},
    );
  }, [isOpen]);
};
